import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Icon } from '#app/shared/ui/icons/Icon.js'

const types = [
  {
    name: 'Exterior:',
    description:
      'En el exterior, realizamos una inspección minuciosa utilizando luz rasante para detectar posibles detalles.',
  },
  {
    name: 'Interior:',
    description:
      'En el interior, revisamos cada componente para garantizar un análisis exhaustivo de su estado.',
  },
]

const variations = [
  {
    name: 'Desgaste:',
    description:
      'Señales producidas por el uso prolongado, como pérdida de color o brillo en plásticos y materiales de cuero.',
    letter: 'D',
  },
  {
    name: 'Irregularidades:',
    description:
      'Pequeñas deformaciones o irregularidades en la chapa o en las llantas que no comprometen la seguridad del vehículo.',
    letter: 'I',
  },
  {
    name: 'Marcas:',
    description:
      'Pequeños impactos o raspones visibles en vidrios, carrocería, interior o ruedas del coche.',
    letter: 'M',
  },
  {
    name: 'Pellizco superficial:',
    description:
      'Daño leve y superficial en el lateral de las ruedas, sin impacto en la seguridad.',
    letter: 'P',
  },
  {
    name: 'Rasguños:',
    description:
      'Rayones o cortes que exponen el material base, ya sea metal o plástico.',
    letter: 'R',
  },
  {
    name: 'Ajustes:',
    description:
      'Reparaciones visibles en superficies como chapa, cristales o elementos interiores.',
    letter: 'A',
  },
]

type Props = {
  setOpen: (val: boolean) => void
}

export default function DetailsModalContent({ setOpen }: Props) {
  return (
    <div
      className={`
        fixed left-1/2 top-1/2 -translate-x-[50%] -translate-y-[50%]
        rounded-base border border-neutral-75 bg-white
      `}
    >
      <div className="relative pb-10 pl-11 pr-[45px] pt-12">
        <Icon
          name="basic/x"
          size="24px"
          className={`absolute right-4 top-4 text-neutral-300`}
          onClick={() => setOpen(false)}
        />
        <p className="text-h4 text-neutral-900">
          ¿Cómo evaluamos las marcas de uso?
        </p>

        <Spacer size="24px" />

        <div className="flex flex-col gap-4">
          {types.map((type) => (
            <p className={`text-base-medium text-neutral-900`} key={type.name}>
              <span className="text-base-bold">{type.name}</span>{' '}
              {type.description}
            </p>
          ))}
        </div>

        <Spacer size="28px" />

        <div className="flex flex-col gap-3">
          {variations.map((variation) => (
            <div className={`flex items-center gap-2`} key={variation.name}>
              <div
                className={`
                  flex h-5 min-w-5 items-center justify-center rounded-full
                  border border-neutral-100
                `}
              >
                <span className="text-subtitle2-semibold text-primary-500">
                  {variation.letter}
                </span>
              </div>
              <p
                className={`text-nowrap text-subtitle1-medium text-neutral-900`}
                key={variation.name}
              >
                <span className="text-subtitle1-bold">{variation.name}</span>{' '}
                {variation.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
